import script from "./InventoryItems.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryItems.vue?vue&type=script&setup=true&lang=js"

import "./InventoryItems.vue?vue&type=style&index=0&id=4b603854&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b603854"]])

export default __exports__